const fireSystem = {
  emitters: [
    {
      id: 1,
      layer: {
        type: 'string',
        value: 'foreground',
      },
      position: {
        type: 'vectorRange',
        value: [
          [0, 1],
          [1, 1],
        ],
      },
      angle: {
        type: 'range',
        value: [-1, -2],
      },
      speed: {
        type: 'range',
        value: [0.4, 1],
      },
      rate: {
        type: 'float',
        value: 1,
      },
      particle: {
        lifetime: {
          type: 'range',
          value: [0.4, 1.2],
        },
        shape: {
          type: 'string',
          value: 'square',
        },
        rotation: {
          type: 'range',
          value: [0, 6.28],
        },

        gravity: {
          type: 'float',
          value: 0.001,
        },
        wobble: {
          type: 'float',
          value: 5,
        },
        scale: {
          type: 'range',
          value: [8, 14],
        },

        scaleRate: {
          type: 'range',
          value: [0.01, 0.1],
        },
        edgeBehaviour: {
          type: 'string',
          value: 'none',
        },
        color: {
          type: 'colorOverLife',
          color: '#f31f1f',
          value: [
            {
              keyframe: 0,
              value: [238, 199, 22, 0.9],
            },
            {
              keyframe: 50,
              value: [243, 31, 31, 0.9],
            },
            {
              keyframe: 100,
              value: [0, 0, 0, 0],
            },
          ],
        },
      },
    },
    {
      id: 2,
      layer: {
        type: 'string',
        value: 'foreground',
      },
      position: {
        type: 'vectorRange',
        value: [
          [0, 1],
          [1, 1],
        ],
      },
      angle: {
        type: 'range',
        value: [-1, -2],
      },
      speed: {
        type: 'range',
        value: [0.4, 1],
      },
      rate: {
        type: 'float',
        value: 11,
      },
      particle: {
        lifetime: {
          type: 'range',
          value: [0.4, 1.2],
        },
        shape: {
          type: 'string',
          value: 'circle',
        },
        rotation: {
          type: 'range',
          value: [0, 6.28],
        },

        gravity: {
          type: 'float',
          value: 0.001,
        },
        wobble: {
          type: 'float',
          value: 5,
        },
        scale: {
          type: 'range',
          value: [2, 8],
        },
        scaleRate: {
          type: 'range',
          value: [0.05, 0.2],
        },
        edgeBehaviour: {
          type: 'string',
          value: 'none',
        },
        color: {
          type: 'colorOverLife',
          color: '#f31f1f',
          value: [
            {
              keyframe: 0,
              value: [238, 199, 22, 0.9],
            },
            {
              keyframe: 50,
              value: [243, 31, 31, 0.9],
            },
            {
              keyframe: 100,
              value: [0, 0, 0, 0],
            },
          ],
        },
      },
    },
    {
      id: 3,
      layer: {
        type: 'string',
        value: 'foreground',
      },
      position: {
        type: 'vectorRange',
        value: [
          [0, 1.01],
          [1, 1.01],
        ],
      },
      angle: {
        type: 'range',
        value: [-1, -2],
      },
      speed: {
        type: 'range',
        value: [1, 3],
      },
      rate: {
        type: 'float',
        value: 15,
      },
      particle: {
        lifetime: {
          type: 'range',
          value: [1.4, 2.2],
        },
        shape: {
          type: 'string',
          value: 'square',
        },
        rotation: {
          type: 'range',
          value: [0, 6.28],
        },

        gravity: {
          type: 'float',
          value: -0.004,
        },
        drag: {
          type: 'vector',
          value: [2, 2],
        },
        scale: {
          type: 'range',
          value: [0.5, 1],
        },

        color: {
          type: 'colorOverLife',
          color: '#fff102',
          value: [
            {
              keyframe: 0,
              value: [255, 255, 0, 0.9],
            },
            {
              keyframe: 80,
              value: [255, 255, 0, 0.9],
            },
            {
              keyframe: 100,
              value: [0, 0, 0, 0],
            },
          ],
        },
      },
    },
    {
      id: 10,
      layer: {
        type: 'string',
        value: 'background',
      },
      position: {
        type: 'vectorRange',
        value: [
          [0, 0.2],
          [1.2, 1.2],
        ],
      },
      angle: {
        type: 'float',
        value: -3.14,
      },
      speed: {
        type: 'float',
        value: 0.1,
      },
      rate: {
        type: 'float',
        value: 11,
      },
      particle: {
        lifetime: {
          type: 'float',
          value: 6,
        },
        shape: {
          type: 'string',
          value: 'circle',
        },

        gravity: {
          type: 'float',
          value: 0.0005,
        },
        scale: {
          type: 'range',
          value: [20, 200],
        },
        edgeBehaviour: {
          type: 'string',
          value: 'none',
        },
        color: {
          type: 'colorOverLife',
          value: [
            {
              keyframe: 0,
              value: [0, 0, 0, 0],
            },
            {
              keyframe: 20,
              value: [0, 0, 0, 0.004],
            },
            {
              keyframe: 40,
              value: [0, 0, 0, 0.004],
            },
            {
              keyframe: 100,
              value: [0, 0, 0, 0],
            },
          ],
        },
      },
    },
  ],
  effects: [
    {
      type: 'gravity',
      emitters: [1, 2],
      energy: 'above',
      data: {
        position: [0.3, 1.8],
        radius: 0.4,
        amount: -0.02,
      },
    },
    {
      type: 'gravity',
      emitters: [1, 2],
      energy: 'above',
      data: {
        position: [0.7, 1.8],
        radius: 0.4,
        amount: -0.02,
      },
    },
    {
      type: 'gravity',
      emitters: [1, 2],
      energy: 'above',
      data: {
        position: [-0.3, 1.2],
        radius: 0.4,
        amount: -0.02,
      },
    },
    {
      type: 'gravity',
      emitters: [1, 2],
      energy: 'above',
      data: {
        position: [1.3, 1.2],
        radius: 0.4,
        amount: -0.02,
      },
    },
    {
      type: 'gravity',
      emitters: [1, 2],
      energy: 'above',
      data: {
        position: [0.2, -1],
        radius: 0.5,
        amount: -0.1,
      },
    },
    {
      type: 'gravity',
      emitters: [1, 2],
      energy: 'above',
      data: {
        position: [0.8, -1],
        radius: 0.5,
        amount: -0.1,
      },
    },
    {
      type: 'time',
      emitters: [1, 2],
      energy: 'above',
      data: {
        amount: 1.5,
      },
    },
    {
      type: 'time',
      emitters: [1, 2],
      energy: 'below',
      data: {
        amount: 0.5,
      },
    },
    {
      type: 'lifetime',
      emitters: [1, 2],
      energy: 'below',
      data: {
        amount: 0.5,
      },
    },
    {
      type: 'spawnOffset',
      emitters: [1, 2],
      energy: 'below',
      data: {
        amount: [0, 0.1],
      },
    },
  ],
}

export default fireSystem
